import { FilterAction } from '@anytag/shared-types';
import { Filter } from '@anytag/shared-molecules';
import { cn } from '@anytag/shared-utils';
import { Template, TemplateProps } from './Template';
import { ProfilePostsFilterFormValues } from './schemaTypes';

export interface ProfilePostsFilterProps
  extends FilterAction<ProfilePostsFilterFormValues>,
    Omit<TemplateProps, 'onSubmit'> {
  className?: string;
}

export const ProfilePostsFilter = ({ filter, setFilter, className, ...templateProps }: ProfilePostsFilterProps) => (
  <Filter.Provider onSubmit={setFilter} values={filter} className={cn('px-4 shadow-list', className)}>
    <Template {...templateProps} />
  </Filter.Provider>
);

export * from './utils';
export * from './schemaTypes';
